export default "__VITE_ASSET__fc05711e__"